export {AssignationModule} from './core/assignation.module';
export {AssignationService} from './core/assignation.service';
export {AssignmentComponentsService} from "./core/assignment-components.service";
